import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-0 lg:justify-between">
          <div className="max-w-md">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-table-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg text-background-50 whitespace-nowrap">
                USFans<span className="text-accent-400">Link</span>
              </span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              {t("footer.disclaimer")}
            </p>
          </div>

          <div className="flex flex-col gap-6 sm:flex-row sm:gap-16">
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-3">
                <a href="#categories" className="hover:text-accent-400 transition-colors">
                  {t("nav.categories")}
                </a>
              </h4>
              <ul className="space-y-2 text-sm text-background-300">
                <li>
                  <Link to="/" className="hover:text-accent-400 transition-colors">
                    {t("nav.home")}
                  </Link>
                </li>
                <li>
                  <a href="#articles" className="hover:text-accent-400 transition-colors">
                    {t("nav.articles")}
                  </a>
                </li>
                <li>
                  <a href="#faq" className="hover:text-accent-400 transition-colors">
                    {t("nav.faq")}
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-3">USFans Spreadsheet</h4>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-background-300 hover:text-accent-400 transition-colors inline-flex items-center gap-1"
              >
                {t("cta.usfans")}
                <i className="ri-external-link-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            © {new Date().getFullYear()} usfanslink.club. {t("footer.rights")}
          </p>
          <p className="text-xs text-background-400">{t("safety.disclaimer")}</p>
        </div>
      </div>
    </footer>
  );
}